import PlayIcon from "../../assets/playIcon.png";
import MessageIcon from "../../assets/messageIcon.png";
import TestPadIcon from "../../assets/testpadIcon.png";
import SessionIcon from "../../assets/sessionIcon.png";
export const engagementCards = [
  {
    imageSrc: TestPadIcon,
    title: "Master the Assessments",
    description: "Participate in quizzes to show true dedication.",
    // description:
    //   "Don't just view the material, master it! Participating in quizzes and assessments shows true dedication.",
    buttonText: "Take Assessment",
    bgColor: "#fff6d8",
  },
  {
    imageSrc: PlayIcon,
    title: "Conquer the Video Library",
    description: "Aim for 100% completion on a module this week.",

    // description:
    //   "Every video you complete powers up your score. Aim for 100% completion on a module this week!",
    buttonText: "Go to Program Hub",
    bgColor: "#dff2ff",
  },
  {
    imageSrc: MessageIcon,
    title: "Become a Forum Sage",
    description: "Aim for 100% completion on a module this week.",

    // description:
    //   "Share your wisdom or ask a great question in the forums. Each quality interaction is a step up!",
    buttonText: "Add Query",
    bgColor: "#bef2f1",
  },

  {
    imageSrc: SessionIcon,
    title: "Ace Your Attendance",
    description: "Join live sessions to connect with instructors.",

    // description:
    //   "Join live sessions to connect with instructors and peers. It's a massive score booster!",
    buttonText: "Join Live Sessions",
    bgColor: "#f8eaff",
  },
];
